import Tabby from "tabbyjs";

const LINKS  = document.querySelectorAll(".tabbyjs__button");

if (LINKS !== null) {
    new Tabby("[data-tabs]");

    window.addEventListener("load", () => {
        if (window.location.hash) {
            const hash = window.location.hash;

            if (window.innerWidth >= 1024) {
                LINKS.forEach((link) => {
                    if (link.getAttribute("href") === hash) {
                        link.click();
                        return false;
                    }
                });
            } else {
                // click on the accordion button instead:
                const tabs_handorgel = document.querySelector("#handorgel1");
                if (tabs_handorgel) {
                    const accordionButton = tabs_handorgel.querySelector(".handorgel__button");
                    if (accordionButton) {
                        accordionButton.click();
                    }
                }
            }
        }
    });
}
